export function buildSelectedAttributesFromModel(attributes) {
    const selectedAttributes = [];

    attributes.forEach(attribute => {
        if (attribute.Values) {
            const attributeValues = attribute.Values.filter(
                value => value.Checked && value.Checked === true);

            attributeValues.forEach(attributeValue => {
                selectedAttributes.push({
                    name: attribute.Name,
                    value: attributeValue.Name
                });
            });
        }
    });

    return selectedAttributes;
}

export function buildFacetNamesFromModel(attributes) {
    if (!attributes) {
        return [];
    }

    return attributes.filter(attribute => attribute.Name)
        .map(attribute => attribute.Name);
}

export function buildStateFromModel({
    SearchString,
    FindClickTracking,
    Articles,
    View,
    Products
}) {
    const state = {
        searchString: SearchString ? SearchString : SearchString,
        selectedAttributes: Articles && Articles.CategoryFacets && Articles.CategoryFacets && Articles.CategoryFacets.Attributes ? buildSelectedAttributesFromModel(Articles.CategoryFacets.Attributes) : [],
        attributes: Articles && Articles.CategoryFacets && Articles.CategoryFacets && Articles.CategoryFacets.Attributes ? Articles.CategoryFacets.Attributes : [],
        productAttributes: Products && Products.ProductFilters && Products.ProductFilters.Attributes ? Products.ProductFilters.Attributes : [],
        selectedProductAttributes: Products && Products.ProductFilters && Products.ProductFilters.Attributes ? buildSelectedAttributesFromModel(Products.ProductFilters.Attributes) : [],
        products: Products && Products.ProductItems ? Products.ProductItems : [],
        productPaginationViewModel: Products && Products.PaginationViewModel ? Products.PaginationViewModel : null,
        articlePaginationViewModel: Articles && Articles.PaginationViewModel ? Articles.PaginationViewModel : null,
        isLoading: false,
        view: View,
        articles: Articles && Articles.ArticleItemViewModels ? Articles.ArticleItemViewModels : [],
        findClickTrackingViewModel: FindClickTracking,
        showMobileFacets: false,
        expandedFacets: Articles && Articles.CategoryFacets && Articles.CategoryFacets.Attributes 
        ? buildFacetNamesFromModel(Articles.CategoryFacets.Attributes) : [],
        expandedProductFacets: Products && Products.ProductFilters && Products.ProductFilters.Attributes 
        ? buildFacetNamesFromModel(Products.ProductFilters.Attributes) : [],
        showMoreFacets: []
    };

    return state;
}

function getRecommendedProducts(recommendations) {
    return recommendations.slice(0, 3).map(({ RecommendationId, TileViewModel }) => {
        return {
            RecommendationId,
            Name: TileViewModel.Name,
            Url: TileViewModel.Url,
            Image: TileViewModel.Image,
            Description: TileViewModel.Description
        };
    });
}
